import DashboardIcon from "assets/svg/sidebar/dashboard.svg";

import TestingIcon from "assets/svg/sidebar/learning.svg";
import UsersIcon from "assets/svg/sidebar/users.svg";
import noun_report from "assets/svg/sidebar/noun_report.svg";
import settings from "assets/svg/sidebar/settings.svg";
import loans from "assets/svg/sidebar/loans.svg";
import agents from "assets/svg/sidebar/agents.svg";
import upload from "assets/svg/sidebar/upload.svg";
import snooze from "assets/svg/sidebar/snooze.svg";

// var SideBariconWidth=24;
export const QUICK_ACTIONS_STATUS = {
  COND_APPROVED: "COND_APPROVED",
  DENIED_2: "DENIED_2",
  FINAL_APPROVED: "FINAL_APPROVED",
  POSTCHECK_3: "POSTCHECK_3",
  BANK: "BANK",
};

export const typeConstant = {
  MORATORIUM: "moratorium",
  FORECLOSURE: "foreclosure",
  DUES_WAIVER: "due-waiver",
};
export const ContentCardSize = {
  maxWidth: "93vw",
};

export const DrawerSize = {
  width: 250,
  closeWidth: 96,
};

// Email Regex
export const EMAIL_REG_EXP =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NUMBER_REG_EXP = /^[0-9]$/;

// Configuration of toast popup
export const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const USER_API_URLS = {
  sendOTP: "/api/v1/subusers/send-otp",
  logIn: "/api/v1/subusers/login",
  subUser: "/api/v1/subuser",
  users: "/api/v1/users",
  getOTP: "/api/v1/users/change-mobile-otp",
  getOutStandingDetails: "/api/v1/users/outstanding-details",
  getUserDetails: "/api/v1/users",
  addBankAccount: "/api/v2/users",
  updateUserDetails: "/api/v1/users",
};

export const PAYMENT_API = {
  listing: "/api/v1/payments/list",
  searchPayment: "api/v1/payments/search/list",
  view: "/api/v1/payments",
  viewMapping: "/api/v1/loans/mapping",
  verify: "/api/v1/payments/verify-payment",
  applyPayment: "/api/v1/payments/apply-payment",
  createPromotionalPayment: "/api/v1/payments/promotional",
  createPayment: "/api/v1/payments/create-paid",
  checkUtr: "/api/v1/payments/check-utr",
  bank: "/api/v1/banks",
  operatingbank: "/api/v1/operating-bank-accounts",
  paymentStatistics: "/api/v1/statistics/payments/hourly-basis-present-day",
  paymentSuccessRate: "/api/v1/statistics/payments/success-rate-statistics",
  paymentModes: "api/v1/payments/payment-mode",
  accoutData: "api/v1/payments/bank-account",
  createRefund: "/api/v2/payments",
  bankList: "/api/v2/banks/branches/ifsc",
};

export const REFUND_API = {
  listing: "/api/v1/refunds/list",
  processRefund: "/api/v1/payments",
  bankAccountDetails: "api/v1/users",
};

export const EXPORT_DOWNLOAD_API = {
  exportExcel: "/api/v1/disbursal/export-to-excel",
};
export const SUBUSER_API = {
  byName: "/api/v1/subusers",
  dropSubuser: "/api/v1/subusers/get-subusers?",
  roles: "/api/v1/subusers/roles",
  allPermissions: "/api/v1/all-permissions",
  subuserPermission: "/api/v1/subuser/permissions/",
  view: "/api/v2/subusers/roles",
};

export const LOAN_API = {
  listing: "/api/v1/loans",
  searchLoanListing: "/api/v1/loans/search/list",
  loanOutstanding: "/api/v1/loans",
  dues: "/api/v1/dues",
  lmsMapping: "/api/v1/loans/lms-mapping",
  paymentReverse: "/api/v1/loans/payment-reverse",
};

export const SNOOZE_API = {
  allowed: "api/v1/snooze/allowed-users",
  blocked: "api/v1/snooze/blocked-users",
  deltedAllowedSnoozed: "api/v1/snooz/allowed-users/loans/",
};

export const TRANSACTION_API = {
  listing: "/api/v1/transactions",
  bankByIfsc: "/api/v1/banks/branches/ifsc",
  retryDisbursement: "/api/v1/disbursal/retry-disbursement/",
  disbursalInfo: "/api/v1/disbursal/info/",
  transactionDeniedList: "api/v1/transactions/deny-reasons",
  transactionDenied: "api/v1/transactions/transaction-deny",
};

export const COLLECTION_API = {
  listing: "/api/v1/collections",
};
export const CONFIGURATION_API = {
  listing: "api/v1/configurations",
  custom_config_list: "api/v1/configurations/custom",
  view: "/api/v1/configurations/history-list",
};
export const FINANCIER = {
  listing: "/api/v1/financiers/ARNOLD/loans",
};
export const VOUCHER_API = {
  listing: "api/v1/disbursal/voucher-list",
};

export const DIGI_REPORT_API = {
  addReport: "/reports/",
  getReportNames: "/offline_reports/list",
  getReportStatusKeys: "/reports/status_list",
  getUserEmails: "/users/",
};

export const DIS_SANITY = {
  listing: "api/v1/disbursal/list",
  search: "api/v1/disbursal/list",
};

export const PENNY_DROP = {
  listing: "api/v1/disbursal/pennydrop/list",
  checkStn: "api/v1/disbursal/pennydrop/list",
  retry: "api/v1/disbursal/retry-beneficiary-verification",
};

export const DISBURSEMENT_STATISTIC = {
  listing: "api/v1/disbursal/statistic",
};
export const BLOCKED_USERS_API = {
  listing: "api/v1/transactions/blocked-users/list",
  delete: "api/v1/transactions/blocked-users",
  create: "api/v1/transactions/blocked-users/create",
  update: "transactions/blocked-users",
};

export const ALLOW_REPEAT_DELINQUENT_API = {
  listing: "api/v1/transactions/repeat-deliquent/list",
  createOrUpdate: "api/v1/transactions/repeat-deliquent/create-or-update",
  delete: "api/v1/transactions/repeat-deliquent",
  inactive: "api/v1/transactions/repeat-deliquent",
};
export const ALLOW_REPEAT_DELINQUENT_API_V2 = {
  listing: "api/v2/transactions/repeat-deliquent/list",
  createOrUpdate: "api/v2/transactions/repeat-deliquent/create-or-update",
  delete: "api/v1/transactions/repeat-deliquent",
  inactive: "api/v1/transactions/repeat-deliquent",
};
export const AUTO_DISBURSEMENT_API = {
  listing: "api/v1/disbursal/panel/autodisbursement",
  dropDown: "api/v1/disbursal/search-option/autoDisbursement",
  settlementDetail: "api/v1/disbursal/settlement-detail",
  disbursementDetail: "api/v1/disbursal/disbursement-detail",
  retryDisburse: "api/v1/disbursal/panel/retryDisbursal",
};

export const OUTBOND_PAYMENT_API = {
  listing: "api/v1/disbursal/panel/outboundpaymentslisting",
  dropDown: "api/v1/disbursal/search-option/outboundPaymentsDetails",
  ReEnqire: "/api/v1/disbursal/outbound-payments-re-enquire",
  statusChange: "api/v1/disbursal/outbound-payments-change-status",
  viewBank: "/api/v1/disbursal/get-user-bank-details",
};
export const PAN_NSDL_API = {
  listing: "api/v1/others/pannsdl/list",
  add: "api/v1/others/pannsdl/create",
  edit: "api/v1/others/pannsdl",
};
export const CIBIL_API = {
  listing: "api/v1/others/cibil/list",
  view: "api/v2/others/cibil",
};

export const USER_BANK_DETAILS_API = {
  listing: "api/v1/others/bank/user-account-list",
  update: "api/v1/others/bank/update-account",
  banklist: "api/v2",
};

export const BANK_LISTING = {
  listing: "api/v1/others/bank/list",
  create: "api/v1/others/bank/create",
};

export const PINCODE_LIST_API = {
  listing: "api/v2/configurations/pincode/list",
  create: "api/v2/configurations/pincode/create",
  dropDownState: "api/v2/configurations/state/list",
  dropDownCity: "api/v2/configurations/city/list",
};
export const CITY_APIS = {
  listing: "api/v2/configurations/city/list",
  create: "api/v1/configuration/city-create",
  update: "api/v1/configuration/city-update",
  dropDownState: "api/v1/configurations/state/list",
};

export const FINANCIER_APPROVAL_APIS = {
  Update: "api/v1/transactions/financier-auto-approve",
  listing: "api/v1/transactions",
};
export const CONFIGURATION_STATE_API = {
  listing: "api/v2/configurations/state/list",
  create: "api/v1/configurations/state/create ",
  update: "/api/v1/configurations ",
};
export const SPLIT_PAYMENT_APIS = {
  listing: "api/v1/payments/cip-listing",
};
export const MERCHANT_OFFER = {
  listing: "api/v1/transactions/promo-offer/list",
  view: "api/v1/transactions/promo-offer",
  create: "api/v1/transactions/promo-offer/create",
};
export const MERCHANT_OFFER_MAP_V2_APIS = {
  listing: "api/v2/transactions/promo-offer/offer-map-list",
  dropdownData: "api/v1/transactions/promo-offer/list",
  add: "api/v2/transactions/promo-offer/offer-map-create",
  update: "api/v2/transactions/promo-offer",
};
export const MERCHANT_OFFER_V2 = {
  listing: "api/v1/transactions/promo-offer/list",
  view: "api/v2/transactions/promo-offer",
  create: "api/v1/transactions/promo-offer/create",
};
export const MERCHANT_OFFER_MAP_APIS = {
  listing: "api/v1/transactions/promo-offer/offer-map-list",
  dropdownData: "api/v1/transactions/promo-offer/list",
  add: "api/v1/transactions/promo-offer/offer-map-create",
  update: "api/v1/transactions/promo-offer",
};
// GB-Grid
export const GB_GRID = {
  listing: "api/v1/transactions/gb-grid/list",
  search: "api/v1/transactions/gb-grid/list",
  modelversion: "api/v1/transactions/gb-grid/enum-list/models",
  modeltype: "api/v1/transactions/gb-grid/enum-list/models",
  modalfuncList: "api/v1/transactions/gb-grid/enum-list/functionality",
  modalmodel: "api/v1/transactions/gb-grid/enum-list/models",
  passwordAdd: "api/v1/transactions/gb-grid/create",
  passwordGB: "api/v1/transactions/gb-grid/update-gb-bands",
  passwordEdit: "api/v1/transactions/gb-grid/update",
};
export const REPORT_DATA_API = {
  listing: "/api/v1/others/reports/list",
  reportUrl: "/api/v1/others/reports",
  create: "/api/v1/others/reports/add_report",
  addreportAccess: "/api/v1/others/reports/set_report_access",
};

export const REPORT_DATA_API_V2 = {
  reportUrl: "/api/v2/others/reports",
  create: "/api/v2/others/reports/add_report",
  addreportAccess: "/api/v2/others/reports/set_report_access",
};

export const LOAN_MATRIX_API = {
  freshGrid:
    "/api/v1/transactions/loan-matrix/list?tab=fresh_grid&limit=100&offset=0",
  repeatGridWl:
    "/api/v1/transactions/loan-matrix/list?tab=repeat_grid&limit=100&offset=0&type=WONDERLAND",
  repeatPfWl:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=WONDERLAND&tab=repeat_processing_fee_grid",
  repeatGrid62Day:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=62DAY&tab=repeat_grid",
  repeatPf62Day:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=62DAY&tab=repeat_processing_fee_grid",
  repeatGrid3Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=3MONTH&tab=repeat_grid",
  repeatGridPF3Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=3MONTH&tab=repeat_processing_fee_grid",
  repeatGrid6Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=6MONTH&tab=repeat_grid",
  repeatGridPF6Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=6MONTH&tab=repeat_processing_fee_grid",
  repeatGrid3oDay:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=30DAY&tab=repeat_grid",
  repeatPf30Day:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=30DAY&tab=repeat_processing_fee_grid",
  repeatGrid12Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=12MONTH&tab=repeat_grid",
  repeatGridPF12Month:
    "/api/v1/transactions/loan-matrix/list?limit=100&offset=0&type=12MONTH&tab=repeat_processing_fee_grid",
  repeatgridWlEdit: "api/v1/transactions/loan-matrix/repeat-mapping",
  sendExcelReport: "api/v1/transactions/loan-matrix/send-excel",
  createTemplate: "api/v1/transactions/loan-matrix/create",
  editTemplateAll: "api/v1/transactions/loan-matrix",
};
export const LOAN_MATRIX_V2_API = {
  freshGrid:
    "/api/v2/transactions/loan-matrix/list?tab=fresh_grid&limit=100&offset=0",
  repeatGridWl:
    "/api/v2/transactions/loan-matrix/list?tab=repeat_grid&limit=100&offset=0&type=WONDERLAND",
  repeatPfWl:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=WONDERLAND&tab=repeat_processing_fee_grid",
  repeatGrid62Day:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=62DAY&tab=repeat_grid",
  repeatPf62Day:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=62DAY&tab=repeat_processing_fee_grid",
  repeatGrid3Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=3MONTH&tab=repeat_grid",
  repeatGridPF3Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=3MONTH&tab=repeat_processing_fee_grid",
  repeatGrid6Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=6MONTH&tab=repeat_grid",
  repeatGridPF6Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=6MONTH&tab=repeat_processing_fee_grid",
  repeatGrid3oDay:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=30DAY&tab=repeat_grid",
  repeatPf30Day:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=30DAY&tab=repeat_processing_fee_grid",
  repeatGrid12Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=12MONTH&tab=repeat_grid",
  repeatGridPF12Month:
    "/api/v2/transactions/loan-matrix/list?limit=100&offset=0&type=12MONTH&tab=repeat_processing_fee_grid",
  repeatgridWlEdit: "api/v1/transactions/loan-matrix/repeat-mapping",
  sendExcelReport: "api/v2/transactions/loan-matrix/send-excel",
  createTemplate: "api/v1/transactions/loan-matrix/create",
  editTemplateAll: "api/v1/transactions/loan-matrix",
};

export const ADMIN_SUBUSER_APIS = {
  listing: "/api/v1/subusers/get-subusers",
  view: "api/v1/subuser",
  agencyList: "/api/v1/subusers/agency-list",
  create: "/api/v2/subuser/create",
  reportTo: "/api/v1/subuser/sales-managers-list",
  export: "/api/v1/subusers/export-excel",
};
export const MERCHANT_APIS = {
  listing: "/api/v1/merchants/list",
  listing: "/api/v1/merchants/list",
  settleList: "/api/v1/merchantsettlement/list",
  merchantUserListing: "/api/v1/merchants/user/list",
  MarkSettledApi: "api/v1/merchantsettlement/mark-settled",
  dropDownData: "api/v1/merchantsettlement/search-option",
  deleteData: "api/v1/disbursal/cashfree-remove-beneficiary",
};

export const CALLING_INTERFACE_APIS = {
  send_notification: "api/v1/subusers/call-center/send_notification",
};

export const UPLOAD_EXCEL = {
  fileUpload: "api/v1/transactions",
  samplefile: "/api/v1/sample-file",
  bulkUpload: "/api/v1/bulk-upload/file",
};
export const EMANDATE_REGISTRATION_APIS = {
  listing: "api/v1/payments/get-emandate-list",
};

export const DELETE_DATA_REQUEST_API = {
  listing: "api/v1/users/delete-account/list",
  updateSatus: "api/v1/users/delete-account/update-status",
};

export const EMANDATE_STATISTIC_REGISTARION = {
  listing: "/api/v1/payments/emandate/registration-statistics",
};

export const EMANDATE_STATISTICS_PAYMENTS = {
  listing: "/api/v1/payments/emandate/payment-statistics",
};
export const ROUTE_NAME = {
  payment: "payment",
  loan: "loan",
  user: "user",
  testing: "testing",
  role: "role",
  refund: "refund",
  dues: "dues",
  nach: "nach",
  statistics: "statistics",
  transaction: "transaction",
  file_upload: "file_upload",
  deposit: "deposit",
  subuser_payment: "subuser_payment",
  collections: "collections",
  configuration: "configuration",
  plebgraph_configuration: "plebgraph_configuration",
  state: "state",
  // koino: "koino",
  financier: "financiers",
  koino: "koino",
  snooze_allowed: "snooze_allowed",
  snooze_blocked: "snooze_blocked",
  reports: "reports",
  voucher: "voucher",
  all: "all",
  auto_disbursement: "auto_disbursement",
  outbound_payment: "outbound_payment",
  disbursement_sanity: "disbursement_sanity",
  penny_drop_sanity: "penny_drop_sanity",
  blocked_users: "blocked_users",
  repeat_deliquent: "repeat_deliquent",
  disbursement_statistic: "disbursement_statistic",
  bank_list: "bank_list",
  pan_nsdl: "pan_nsdl",
  pincode: "pincode",
  city: "city",
  upload_denied2_transactions: "upload_denied2_transactions",
  upload_loan_snapshot: "upload_loan_snapshot",
  communication_bulk_upload: "communication_bulk_upload",
  useredit: "useredit",
  cibil: "cibil",
  ViewCibil: "ViewCibil",
  ViewrResponse: "ViewrResponse",
  userbankdetails: "userbankdetails",
  split_payments: "split_payments",
  financier_approval: "financier_approval",
  check_utr: "check_utr",
  banklisting: "banklisting",
  splitPayment: "splitPayment",
  financierapproval: "financierapproval",
  merchantView: "merchantView",
  editMerchant: "editMerchant",
  addMerchant: "addMerchant",
  LoanMatrix: "LoanMatrix",
  user_bank_details: "user_bank_details",
  digi_data_report: "digi_data_report",
  merchant_offer: "merchant_offer",
  merchant_offer_map: "merchant_offer_map",
  gb_grid: "gb_grid",
  plebgraph_gb_grid: "plebgraph_gb_grid",
  loan_matrix: "loan_matrix",
  LoanMatrixAdd: "LoanMatrixAdd",
  LoanMatrixEdit: "LoanMatrixEdit",
  offersPage: "offersPage",
  subuser: "subuser",
  merchant_settlement: "merchant_settlement",
  merchants: "merchants",
  global_header: "global_header",
  report_data: "report_data",
  emandate_registration: "emandate_registration",
  delete_account: "delete_account",
};

export const PERMISSIONS = {
  dashboard: { list: "list", details: "details" },
  koino: {
    upload_transit_user: "upload_transit_user",
  },
  statistics: {
    hourly_basis_payments_count: "hourly_basis_payments_count",
    success_rate_statistics: "success_rate_statistics",
    view: "view",
  },
  loan: {
    list: "list",
    view: "view",
    transaction_view: "transaction_view",
    user_view: "user_view",
    bulk_upload: "bulk_upload",
    upload_bulk_dues_waiver: "upload_bulk_dues_waiver",
    moratorium_upload: "moratorium_upload",
    upload_cip_bulk_dues_waiver: "upload_cip_bulk_dues_waiver",
    generate_soa: "generate_soa",
    comments: "comments",
    send_user_payment_link: "send_user_payment_link",
    payment_link: "payment_link",
    sync_loan: "sync_loan",
    cancel_loan: "cancel_loan",
    loan_detail_and_repayment: "loan_detail_and_repayment",
    payment: "payment",
    offer_given: "offer_given",
    other_info: "other_info",
    view_mapping: "view_mapping",
    loan_payment: "loan_payment",
    loan_other_payments: "loan_other_payments",
    transaction_payments: "transaction_payments",
    loan_payments_bounce: "loan_payments_bounce",
    all_payments: "all_payments",
    payment_view: "payment_view",
    payment_mapping_view: "payment_mapping_view",
    moratorium_details: "moratorium_details",
    moratorium_activate: "moratorium_activate",
    moratorium_deactivate: "moratorium_deactivate",
    settlement_details: "settlement_details",
    settlement_activate: "settlement_activate",
    settlement_deactivate: "settlement_deactivate",
    restructure_details: "restructure_details",
    restructure_activate: "restructure_activate",
    restructure_deactivate: "restructure_deactivate",
    emi_holiday_details: "emi_holiday_details",
    emi_holiday_activate: "emi_holiday_activate",
    emi_holiday_deactivate: "emi_holiday_deactivate",
    send_moratorium_payment_link: "send_moratorium_payment_link",
    moratorium_payment_link: "moratorium_payment_link",
    copy_shorturl: "copy_shorturl",
    mark_moratorium: "mark_moratorium",
    due_waiver_activate: "due_waiver_activate",
    due_waiver_deactivate: "due_waiver_deactivate",
    send_due_waiver_payment_link: "send_due_waiver_payment_link",
    due_waiver_payment_link: "due_waiver_payment_link",
    send_foreclosure_payment_link: "send_foreclosure_payment_link",
    foreclosure_link: "foreclosure_link",
    send_settlement_payment_link: "send_settlement_payment_link",
    settlement_payment_link: "settlement_payment_link",
    send_emi_holiday_payment_link: "send_emi_holiday_payment_link",
    send_restructure_payment_link: "send_restructure_payment_link",
    apply_foreclosure_payment: "apply_foreclosure_payment",
    disallow_dues_waiver: "disallow_dues_waiver",
    send_campaign_payment_link: "send_campaign_payment_link",
    download_noc_letter: "download_noc_letter",
    send_noc_letter: "send_noc_letter",
    due_waiver_details: "due_waiver_details",
    calculate_foreclosure: "calculate_foreclosure",
    date: "date",
    moratorium_apply: "moratorium_apply",
    dues_waive_off: "dues_waive_off",
    undo_dues_waive_off: "undo_dues_waive_off",
    emi_holiday_payment_link: "emi_holiday_payment_link",
    restructure_payment_link: "restructure_payment_link",
    dues_list: "dues_list",
    loan_bank_details: "loan_bank_details",
  },
  user: {
    list: "list",
    view: "view",
    update: "update",
    kyc_tab: "kyc_tab",
    documents_tab: "documents_tab",
    transactions_tab: "transactions_tab",
    loan_and_payment_tab: "loan_and_payment_tab",
    doc_view_ocr: "doc_view_ocr",
    transaction_view: "transaction_view",
    loan_details_tab: "loan_details_tab",
    payment_history_tab: "payment_history_tab",
    payment_view: "payment_view",
    change_mobile_otp: "change_mobile_otp",
    change_mobile_number: "change_mobile_number",
    comments: "comments",
    send_payment_link: "send_payment_link",
    payment_link: "payment_link",
    other_info: "other_info",
    pan_verification_details: "pan_verification_details",
  },
  transaction: {
    list: "list",
    view: "view",
    user_view: "user_view",
    cust_care_comment: "cust_care_comment",
    under_writer_comment: "under_writer_comment",
    quick_action: "quick_action",
    welcome_letter: "welcome_letter",
    sanction_letter: "sanction_letter",
    product_merchant_details_tab: "product_merchant_details_tab",
    nach_details_tab: "nach_details_tab",
    income_Data_tab: "income_Data_tab",
    verify_bank_account: "verify_bank_account",
    transaction_tab: "transaction_tab",
    txn_merchant_offer_view: "txn_merchant_offer_view",
    loan_view: "loan_view",
    payment_view: "payment_view",
    snapshot_tab: "snapshot_tab",
    document_docket_tab: "document_docket_tab",
    download_nach: "download_nach",
    document_dockets_view_ocr: "document_dockets_view_ocr",
    actions_tab: "actions_tab",
    convert_to_d2: "convert_to_d2",
    financier_approve: "financier_approve",
    credit_and_fraud_tab: "credit_and_fraud_tab",
    credit_fraud_request_data: "credit_fraud_request_data",
    credit_fraud_response_data: "credit_fraud_response_data",
    download_docket: "download_docket",
    cibil_data_tab: "cibil_data_tab",
    demographics_tab: "demographics_tab",
    demographics_customer_view: "demographics_customer_view",
    add_user_bank_acccount: "add_user_bank_acccount",
    customer_application_letter: "customer_application_letter",
  },
  financier_approval: {
    list: "list",
    transaction_view: "transaction_view",
    check_all: "check_all",
    approve: "approve",
    denied: "denied",
  },

  payment: {
    list: "list",
    view: "view",
    user_view: "user_view",
    add_payment: "add_payment",
    add_promotional_payment: "add_promotional_payment",
    upload: "upload",
    upload_idfc_vpa_payment: "upload_idfc_vpa_payment",
    upload_yes_bank_vpa_payment: "upload_yes_bank_vpa_payment",
    payment_cancel: "payment_cancel",
    bulk_snooze_upload: "bulk_snooze_upload",
    view_mapping: "view_mapping",
    apply_payment: "apply_payment",
    change_reason: "change_reason",
    mark_unpaid: "mark_unpaid",
    mapping_reverse: "mapping_reverse",
    loan_view: "loan_view",
    check_utr: "check_utr",
    add_paid_payment: "add_paid_payment",
    verify_payment: "verify_payment",
    change_payment_reason: "change_payment_reason",
    capture_razorpay_payment: "capture_razorpay_payment",
    generate_link: "generate_link",
    refund_view: "refund_view",
    initiate_bulk_refund: "initiate_bulk_refund",
    extra_payment_bulk_upload: "extra_payment_bulk_upload",
  },
  subuser_payment: {
    list: "list",
    view: "view",
    capture: "capture",
    verify_subuser_payment: "verify_subuser_payment",
  },
  split_payments: {
    list: "list",
    loan_view: "loan_view",
    payment_view: "payment_view",
    user_view: "user_view",
    auto_retry: "auto_retry",
  },
  deposit: {
    list: "list",
    view: "view",
    create: "create",
    bank_deposit_slip_number: "bank_deposit_slip_number",
    verify: "verify",
    cash_deposit_reference_number: "cash_deposit_reference_number",
    remove_payment: "remove_payment",
    add_payment: "add_payment",
    uploadslip: "uploadslip",
  },
  refund: {
    list: "list",
    view: "view",
    create: "create",
    payment_view: "payment_view",
    user_view: "user_view",
    bulk_upload_marked_refunded: "bulk_upload_marked_refunded",
    marked_refunded: "marked_refunded",
    update_refund: "update_refund",
    cancel_refund: "cancel_refund",
    export_excel: "export_excel",
  },
  check_utr: {
    list: "list",
    user_view: "user_view",
    payment_view: "payment_view",
  },
  role: {
    list: "list",
    update: "update",
    create: "create",
    view: "view",
  },
  file_upload: {
    list: "list",
    view: "view",
    download: "download",
    cancel_upload: "cancel_upload",
  },
  configuration: {
    list: "list",
    update: "update",
    create: "create",
    view: "view",
  },
  plebgraph_configuration: {
    list: "list",
    update: "update",
    create: "create",
    view: "view",
  },
  state: {
    state_list: "state_list",
    state_create: "state_create",
    state_update: "state_update",
    state_view: "state_view",
  },
  city: {
    city_list: "city_list",
    city_create: "city_create",
    city_update: "city_update",
    city_view: "city_view",
  },
  pincode: {
    pincode_list: "pincode_list",
    pincode_create: "pincode_create",
    pincode_update: "pincode_update",
    pincode_view: "pincode_view",
  },
  merchants: {
    list: "list",
    view: "view",
    update_merchant: "update_merchant",
    export_excel: "export_excel",
  },
  merchant_settlement: {
    list: "list",
    view: "view",
    export_to_excel: "export_to_excel",
    mark_as_settled: "mark_as_settled",
    adjust_settlement: "adjust_settlement",
    upload_excel: "upload_excel",
    delete_beneficiary: "delete_beneficiary",
  },
  merchant_offer_map: {
    offer_map_list: "offer_map_list",
    offer_map_create: "offer_map_create",
    offer_map_update: "offer_map_update",
    offer_map_view: "offer_map_view",
  },
  merchant_offer: {
    merchant_list: "merchant_list",
    merchant_create: "merchant_create",
    merchant_view: "merchant_view",
  },
  financiers: {
    list: "list",
    view: "view",
  },
  digi_data_report: {
    list: "list",
    create: "create",
    view: "view",
    extract_report: "extract_report",
  },
  pan_nsdl: {
    pannsdl_list: "pannsdl_list",
    pannsdl_create: "pannsdl_create",
    pannsdl_update: "pannsdl_update",
    pannsdl_delete: "pannsdl_delete",
  },
  cibil: {
    list: "list",
    view: "view",
    view_response: "view_response",
    add: "add",
    user_view: "user_view",
    transaction_view: "transaction_view",
    download_file: "download_file",
  },
  user_bank_details: {
    list: "list",
    update_account: "update_account",
    view: "view",
    update: "update",
    user_view: "user_view",
  },
  bank_list: {
    list: "list",
    update: "update",
  },
  upload_denied2_transactions: {
    view: "view",
    upload_users: "upload_users",
  },
  upload_loan_snapshot: {
    view: "view",
    upload_users: "upload_users",
  },
  communication_bulk_upload: {
    view: "view",
    upload_users: "upload_users",
  },
  outbound_payment: {
    list: "list",
    export_excel: "export_excel",
    view_response: "view_response",
    view_bank: "view_bank",
    re_enquire: "re_enquire",
    change_status: "change_status",
  },
  auto_disbursement: {
    list: "list",
    transaction_view: "transaction_view",
    settlement_details: "settlement_details",
    bank_details: "bank_details",
    disbursement_details: "disbursement_details",
    export_excel: "export_excel",
    retry_disbursement: "retry_disbursement",
    user_view: "user_view",
  },
  snooze_blocked: {
    list: "list",
    create: "create",
    update: "update",
    remove: "remove",
    user_view: "user_view",
    upload_users: "upload_users",
    remove_blocked_users: "remove_blocked_users",
  },
  snooze_allowed: {
    list: "list",
    create: "create",
    remove: "remove",
    upload_users: "upload_users",
    remove_blocked_users: "remove_blocked_users",
    user_view: "user_view",
    loan_view: "loan_view",
    deactivate_record: "deactivate_record",
  },
  repeat_deliquent: {
    list: "list",
    create: "create",
    delete: "delete",
    update: "update",
    change_status: "change_status",
    upload_excel: "upload_excel",
  },
  blocked_users: {
    list: "list",
    create: "create",
    delete: "delete",
    update: "update",
    upload_excel: "upload_excel",
  },
  penny_drop_sanity: {
    list: "list",
    retry_beneficiary_verification: "retry_beneficiary_verification",
    check_yesterday_sanity: "check_yesterday_sanity",
  },
  disbursement_statistic: {
    view: "view",
    check_yesterday_sanity: "check_yesterday_sanity",
  },
  disbursement_sanity: {
    view: "view",
  },
  loan_matrix: {
    list: "list",
    create: "create",
    update: "update",
    send_excel: "send_excel",
    fresh_grid_update: "fresh_grid_update",
  },
  gb_grid: {
    list: "list",
    update_gb_bands: "update_gb_bands",
    update: "update",
    add_function: "add_function",
  },
  plebgraph_gb_grid: {
    list: "list",
    update_gb_bands: "update_gb_bands",
    update: "update",
    add_function: "add_function",
  },
  collections: {
    lowPriorityBulkUpload: "lowPriorityBulkUpload",
    addUnifiedComments: "addUnifiedComments",
    "kalerya-call": "kalerya-call",
  },
  all: "all",
  subuser: {
    list_name: "list_name",
    details: "details",
    update: "update",
    update_contact: "update_contact",
    create: "create",
    export_excel: "export_excel",
  },
  global_header: {
    click_to_call: "click_to_call",
    low_priority_bulk_upload: "low_priority_bulk_upload",
  },
  report_data: {
    report_list: "report_list",
    report_view: "report_view",
    report_create: "report_create",
    report_update: "report_update",
    report_mail: "report_mail",
    report_download: "report_download",
    report_access: "report_access",
  },
  emandate_registration: {
    emandate_list: "emandate_list",
    statistics_registration: "statistics_registration",
    statistics_payments: "statistics_payments",
    transaction_view: "transaction_view",
    user_view: "user_view",
  },
  delete_account: {
    list: "list",
    update_status: "update_status",
  },
};

export const ROUTES_VAR = {
  signIn: "/sign-in",
  dashboard: "/",
  loans: "/loans",
  loan: "/loans/:id",
  users: "/users",
  user: "/users/:id",
  transactions: "/transactions",
  transaction: "/transactions/:id",
  documentViewer: "/document-viewer",
  testing: "/testing-panel",
  nach: "/nach",
  nachDetail: "/nach/:id",
  mandate: "/mandate",
  mandateDetail: "/mandate/:id",
  docket_tracking_panel: {
    link: "/docket-tracking-panel",
    external_docket: "/docket-tracking-panel/external-docket",
  },
  roles: "/roles",
  role_edit: "/roles/update/:id",
  role_view: "/roles/view/:id",
  payments: "/payments",
  refund: "/refund",
  refund_view: "/refund/:id",
  check_utr: "/utr",
  payment_view: "/payments/:id",
  statistics: "/statistics",
  fileUpload: "/uploads",
  deposits: "/deposits",
  deposit_view: "/deposits/:id",
  subuserPayments: "/subuser_payments",
  subuserPayments_view: "/subuser_payments/:id",
  configuration: "/configuration",
  plebgraph_configuration: "/plebgraph_configuration",
  koino: "/koino",
  financier: "/financier",
  financier_view: "/financier/:id",
  auto_disbursement: "/auto-disbursement",
  outbond_payment: "/outbond-payment",
  snoozed_allowed: "/snoozed-allowed",
  snoozed_blocked: "/snoozed-blocked",
  reports: "/reports",
  vouchers: "/vouchers",
  loan_matrix: "/fastcash-loan-matrix",
  // loan_matrix_v2: "/fastcash-loan-matrix-v2",
  loan_matrix_offer_view: "/promo-offers/view/:id",
  digi_report: "/digi-data-report",
  blocked_users: "/blocked-users",
  allow_repeat_delinquent: "/allow-repeat-delinquent",
  // allow_repeat_delinquent_v2: "/allow-repeat-delinquent-v2",
  penny_drop_listing: "/penny_drop_listing",
  dis_sanity_list: "/dis_sanity_list",
  penny_drop: "/penny-drop",
  merchant_offer_map_edit: "/merchant-offer-map/edit/:id",
  merchant_offer_map_add: "/merchant_offer_map_add",
  // merchant_offer_map_edit_v2: "/merchant-offer-map-v2/edit/:id",
  // merchant_offer_map_add_v2: "/merchant_offer_map_add_v2",
  merchant_offer_map: "/merchant-offer-map/view/:id",
  // merchant_offer_map_v2: "/merchant-offer-map-v2/view/:id",
  loan_matrix_add: "/fastcash-loan-matrix/add",
  // loan_matrix_add_v2: "/fastcash-loan-matrix-v2/add",
  loan_matrix_edit: "/fastcash-loan-matrix/edit/:reference_number",
  // loan_matrix_edit_v2: "/fastcash-loan-matrix-v2/edit/:reference_number",
  disbursement_statistics: "/disbursement-statistic",
  configurationSection: "/configuration-section",
  auto_disbursement: "/auto-disbursement",
  outbond_payment: "/outbond-payment",
  offers_page: "/promo-offers/view/:id",
  // offers_page_v2: "/promo-offers-v2/view/:id",
  pincode_list: "/pincodelist",
  loc_master: "/locmaster",
  loc_statement: "/locstatement",
  billing_cycle: "/billingcycle",
  sor_master: "/sormaster",
  merchant_map: "/merchantMap",
  // merchant_map_v2: "/merchantMap-v2",
  // merchant_offer: "/merchantOffer",
  merchant_offer: "/merchantOffer",
  //  merchant_offer_v2: "/merchantOffer-v2",
  offer_merchant_add: "/offer_merchant_add",
  // offer_merchant_add_v2: "/offer-merchant-add-v2",
  state: "/state",
  merchantSettlement: "/merchantSettlement",
  merchant_list: "/merchant_list",
  merchant_view: "/merchant_view",
  merchant_edit: "/merchant_edit",
  city: "/city",
  gb_grid: "/gb_grid",
  plebgraph_gb_grid: "/plebgraph_gb_grid",
  merchant_sites: "/merchant_sites",
  merchant_site_add: "/merchant_site_add",
  merchant_site_edit: "/merchant_site_edit",
  merchant_offer_assign: "/merchant_offer_assign",
  merchant_view_offer: "/merchant_view_offer",
  loc_transaction: "/loc_transaction",
  Pan_nsdl: "/Pan_nsdl",
  bank_listing: "/bank_listing",
  configurationSection: "/configuration-section",
  pincode_list: "/pincodelist",
  state: "/state",
  city: "/city",
  transaction_denied: "/transaction_denied",
  loansnapshot_upload: "/loansnapshot_upload",
  user_edit: "/user_edit/:Id",
  // Pan_nsdl:"/Pan_nsdl",
  // user_edit:"/user_edit/:Id",
  cibil: "/cibil",
  View_cibil: "/View_cibil/:id",
  View_response: "/View_response",
  user_bank_details: "/user_bank_details",
  // bank_listing:"/bank_listing",
  splitpay_view: "/splitpay_view",
  financier_approval: "/financier_approval",
  merchant_offer: "/merchantOffer",
  merchant_offer_v2: "/merchantOffer-v2",
  offer_merchant_add: "/offer_merchant_add",
  offer_merchant_add_v2: "/offer-merchant-add-v2",
  merchant_map: "/merchantMap",
  merchant_map_v2: "/merchantMap-v2",
  merchant_offer_map_edit: "/merchant-offer-map/edit/:id",
  merchant_offer_map_edit_v2: "/merchant-offer-map-v2/edit/:id",
  merchant_offer_map_add: "/merchant_offer_map_add",
  merchant_offer_map_add_v2: "/merchant_offer_map_add_v2",
  merchant_offer_map: "/merchant-offer-map/view/:id",
  merchant_offer_map_v2: "/merchant-offer-map-v2/view/:id",
  gb_grid: "/gb_grid",
  plebgraph_gb_grid: "/plebgraph_gb_grid",
  loan_matrix_add: "/fastcash-loan-matrix/add",
  loan_matrix_edit: "/fastcash-loan-matrix/edit/:reference_number",
  loan_matrix_add_v2: "/fastcash-loan-matrix-v2/add",
  loan_matrix_edit_v2: "/fastcash-loan-matrix-v2/edit/:reference_number",
  offers_page: "/promo-offers/view/:id",
  offers_page_v2: "/promo-offers-v2/view/:id",
  loan_matrix: "/fastcash-loan-matrix",
  admin_subuser: "/admin-subuser",
  add_roles: "/add_roles",
  merchant_list: "/merchant_list",
  merchantSettlement: "/merchantSettlement",
  report_data: "/report-data",
  report_data_v2: "/report-data-v2",
  emandate_registration: "/emandate_registration",
  delete_data_request: "/delete-data-request",
  communication_upload: "/communication_upload",
  statistics_payments: "/statistics_payments",
  statistics_registration: "/statistics_registration",
  // payment: {
  //   link: "/payment-panel",
  //   payment: "/payment-panel/payment",
  //   payment_view: "/payment-panel/payment/view/:id",
  //   razorpay: "/payment-panel/razorpay",
  //   payu: "/payment-panel/payu",
  //   paytm: "/payment-panel/paytm",
  // },
};

export const SIDEBAR_LINKS = [
  {
    text: "Dashboard",
    link: ROUTES_VAR.dashboard,
    icon: DashboardIcon,
    route: "/",
  },
  {
    text: "Purple",
    link: ROUTES_VAR.dashboard,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "GB Grid",
        link: ROUTES_VAR.gb_grid,
        icon: snooze,
        route: ROUTE_NAME.gb_grid,
      },
      {
        text: "Plebgraph GB Grid",
        link: ROUTES_VAR.plebgraph_gb_grid,
        icon: snooze,
        route: ROUTE_NAME.plebgraph_gb_grid,
      },
      // removing v1 version
      // {
      //   text: "Loan Matrix",
      //   link: ROUTES_VAR.loan_matrix,
      //   icon: snooze,
      //   route: ROUTE_NAME.loan_matrix,
      // },
      {
        text: "Loan Matrix",
        link: ROUTES_VAR.loan_matrix,
        icon: snooze,
        route: ROUTE_NAME.loan_matrix,
      },
      {
        text: "Disbursement Sanity",
        link: ROUTES_VAR.dis_sanity_list,
        icon: snooze,
        route: ROUTE_NAME.disbursement_sanity,
      },
      {
        text: "Disbursement Statistics",
        link: ROUTES_VAR.disbursement_statistics,
        icon: snooze,
        route: ROUTE_NAME.disbursement_statistic,
      },
      {
        text: "Penny Drop",
        link: ROUTES_VAR.penny_drop,
        icon: snooze,
        route: ROUTE_NAME.penny_drop_sanity,
      },
      {
        text: "Blocked User",
        link: ROUTES_VAR.blocked_users,
        icon: snooze,
        route: ROUTE_NAME.blocked_users,
      },
      // removing v1 version
      // {
      //   text: "Allow Repeat Delinquent",
      //   link: ROUTES_VAR.allow_repeat_delinquent,
      //   icon: snooze,
      //   route: ROUTE_NAME.repeat_deliquent,
      // },
      {
        text: "Allow Repeat Delinquent",
        link: ROUTES_VAR.allow_repeat_delinquent,
        icon: snooze,
        route: ROUTE_NAME.repeat_deliquent,
      },
      {
        text: "Allow Snooze User",
        link: ROUTES_VAR.snoozed_allowed,
        icon: snooze,
        route: ROUTE_NAME.snooze_allowed,
      },
      {
        text: "Blocked Snooze User",
        link: ROUTES_VAR.snoozed_blocked,
        icon: snooze,
        route: ROUTE_NAME.snooze_blocked,
      },
      {
        text: "Auto Disbursement",
        link: ROUTES_VAR.auto_disbursement,
        icon: snooze,
        route: ROUTE_NAME.auto_disbursement,
      },
      {
        text: "Outbound Payments",
        link: ROUTES_VAR.outbond_payment,
        icon: snooze,
        route: ROUTE_NAME.outbound_payment,
      },
    ],
  },
  {
    text: "Statistics",
    link: ROUTES_VAR.statistics,
    icon: noun_report,
    route: ROUTE_NAME.statistics,
  },
  {
    text: "Loans",
    link: ROUTES_VAR.loans,
    icon: loans,
    route: ROUTE_NAME.loan,
  },
  {
    text: "Users",
    link: ROUTES_VAR.users,
    icon: UsersIcon,
    route: ROUTE_NAME.user,
  },
  {
    text: "Transactions",
    link: ROUTES_VAR.transactions,
    icon: noun_report,
    route: ROUTE_NAME.transaction,
  },
  {
    text: "Financier Approval",
    link: ROUTES_VAR.financier_approval,
    icon: noun_report,
    route: ROUTE_NAME.financier_approval,
  },
  {
    text: "Payments",
    link: ROUTES_VAR.payments,
    icon: noun_report,
    route: ROUTE_NAME.payment,
  },
  {
    text: "Subuser payments",
    link: ROUTES_VAR.subuserPayments,
    icon: noun_report,
    route: ROUTE_NAME.subuser_payment,
  },
  {
    text: "Split Payment View",
    link: ROUTES_VAR.splitpay_view,
    icon: noun_report,
    route: ROUTE_NAME.split_payments,
  },
  {
    text: "Emandate",
    link: ROUTES_VAR,
    icon: noun_report,
    route: "/",
    child: [
      {
        text: "Emandate Registration",
        link: ROUTES_VAR.emandate_registration,
        icon: noun_report,
        route: ROUTE_NAME.emandate_registration,
      },
      {
        text: "Registration Statistics",
        link: ROUTES_VAR.statistics_registration,
        icon: noun_report,
        route: ROUTE_NAME.emandate_registration,
      },
      {
        text: "Payments Statistics",
        link: ROUTES_VAR.statistics_payments,
        icon: noun_report,
        route: ROUTE_NAME.emandate_registration,
      },
    ],
  },
  {
    text: "Deposits",
    link: ROUTES_VAR.deposits,
    icon: loans,
    route: ROUTE_NAME.deposit,
  },
  {
    text: "Refund",
    link: ROUTES_VAR.refund,
    icon: noun_report,
    route: ROUTE_NAME.refund,
  },
  {
    text: "Check UTR",
    link: ROUTES_VAR.check_utr,
    icon: noun_report,
    route: ROUTE_NAME.check_utr,
  },
  {
    text: "Testing panel",
    link: ROUTES_VAR.testing,
    icon: TestingIcon,
    route: ROUTE_NAME.testing,
  },
  {
    text: "File Uploads",
    link: ROUTES_VAR.fileUpload,
    icon: upload,
    route: ROUTE_NAME.file_upload,
  },
  {
    text: "Delete Data Request",
    link: ROUTES_VAR.delete_data_request,
    icon: upload,
    route: ROUTE_NAME.delete_account,
  },

  {
    text: "Configurations",
    link: ROUTES_VAR,
    icon: settings,
    route: "/",
    child: [
      {
        text: "Configuration",
        link: ROUTES_VAR.configuration,
        icon: settings,
        route: ROUTE_NAME.configuration,
      },
      {
        text: "Plebgraph Configuration",
        link: ROUTES_VAR.plebgraph_configuration,
        icon: settings,
        route: ROUTE_NAME.plebgraph_configuration,
      },
    ],
  },

  {
    text: "Offers",
    link: ROUTES_VAR,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "Merchant Offer",
        link: ROUTES_VAR.merchant_offer,
        icon: loans,
        route: ROUTE_NAME.merchant_offer,
      },
      {
        text: "Merchant Offer Map",
        link: ROUTES_VAR.merchant_map,
        icon: loans,
        route: ROUTE_NAME.merchant_offer_map,
      },
    ],
  },
  {
    text: "Main Configuration",
    link: ROUTES_VAR.configurationSection,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "State",
        link: ROUTES_VAR.state,
        icon: settings,
        route: ROUTE_NAME.state,
      },
      {
        text: "City",
        link: ROUTES_VAR.city,
        icon: settings,
        route: ROUTE_NAME.city,
      },
      {
        text: "Pincode",
        link: ROUTES_VAR.pincode_list,
        icon: settings,
        route: ROUTE_NAME.pincode,
      },
    ],
  },
  {
    text: "Admin Management",
    link: ROUTES_VAR,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "Roles panel",
        link: ROUTES_VAR.roles,
        icon: agents,
        route: ROUTE_NAME.role,
      },
      {
        text: "Subuser",
        link: ROUTES_VAR.admin_subuser,
        icon: UsersIcon,
        route: ROUTE_NAME.subuser,
      },
    ],
  },
  {
    text: "Merchant",
    link: ROUTES_VAR,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "Merchant List",
        link: ROUTES_VAR.merchant_list,
        icon: snooze,
        route: ROUTE_NAME.merchants,
      },
      {
        text: "Merchant Settlement",
        link: ROUTES_VAR.merchantSettlement,
        icon: UsersIcon,
        route: ROUTE_NAME.merchantsettlement,
      },
    ],
  },

  {
    text: "Financier",
    link: ROUTES_VAR.financier,
    icon: settings,
    route: ROUTE_NAME.financier,
  },
  {
    text: "Digi Data Report",
    link: ROUTES_VAR.digi_report,
    icon: noun_report,
    route: ROUTE_NAME.digi_data_report,
  },
  {
    text: "Others",
    link: ROUTES_VAR.Pan_nsdl,
    icon: DashboardIcon,
    route: "/",
    child: [
      {
        text: "Pan Nsdl Data",
        link: ROUTES_VAR.Pan_nsdl,
        icon: loans,
        route: ROUTE_NAME.pan_nsdl,
      },
      {
        text: "Bank List",
        link: ROUTES_VAR.bank_listing,
        icon: loans,
        route: ROUTE_NAME.bank_list,
      },
      // {
      //   text: "Report Data",
      //   link: ROUTES_VAR.report_data,
      //   icon: loans,
      //   route: ROUTE_NAME.report_data,
      // },
      {
        text: "Report Data",
        link: ROUTES_VAR.report_data,
        icon: loans,
        route: ROUTE_NAME.report_data,
      },
      {
        text: "Transaction Denied 2",
        link: ROUTES_VAR.transaction_denied,
        icon: loans,
        route: ROUTE_NAME.upload_denied2_transactions,
      },
      {
        text: "Cibil",
        link: ROUTES_VAR.cibil,
        icon: loans,
        route: ROUTE_NAME.cibil,
      },
      {
        text: "User Bank Details",
        link: ROUTES_VAR.user_bank_details,
        icon: loans,
        route: ROUTE_NAME.user_bank_details,
      },
      {
        text: "Loan Snapshot Upload",
        link: ROUTES_VAR.loansnapshot_upload,
        icon: loans,
        route: ROUTE_NAME.upload_loan_snapshot,
      },
      {
        text: "Bulk Communication",
        link: ROUTES_VAR.communication_upload,
        icon: loans,
        route: ROUTE_NAME.communication_bulk_upload,
      },
    ],
  },

  // {
  //   text: "Reports",
  //   link: ROUTES_VAR.reports,
  //   icon: report,
  //   route: ROUTE_NAME.reports,
  // },
  // {
  //   text: "Vouchers",
  //   link: ROUTES_VAR.vouchers,
  //   icon: report,
  //   route: ROUTE_NAME.voucher,
  // },

  // {
  //   text: "Transactions",
  //   link: ROUTES_VAR.transactions,
  //   icon: DashboardIcon
  //     // <RefundIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[2], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Underwriting Panel",
  //   link: "/underwriting-panel",
  //   icon: AgentsIcon
  //     // <SettingsIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[3], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Pre Post Disbursal",
  //   link: "/pre-post-disbursal",
  //   icon: DashboardIcon
  //     // <SettingsIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[4], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Refund",
  //   link: "/refund",
  //   icon: DashboardIcon
  //     // <RefundIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[5], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "CPV Panel",
  //   link: "/cpv-panel",
  //   icon: DashboardIcon
  //     // <RefundIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //     // />

  // },
  // // {
  // //   text: "NACH Registration Panel",
  // //   link: "/nach-registration-panel",
  // //   icon: DashboardIcon,
  // //     // <DocIcon
  // //     //   className="mx-auto"
  // //     //   style={{ color: SIDEBAR_COLORS[1], fontSize: 20 }}
  // //     // />

  // //   child: [
  // //     {
  // //       text: "NACH Registration Panel",
  // //       link: "/nach-registration-panel",
  // //       icon: ""
  // //     },
  // //     {
  // //       text: "Registration Batches",
  // //       link: "/nach-registration-panel/registration-batches",
  // //       icon: ""
  // //     }
  // //   ]
  // // },
  // // {
  // //   text: "Docket Tracking Panel",
  // //   link: "/docket-tracking-panel",
  // //   icon: DashboardIcon,
  // //     // <DocIcon
  // //     //   className="mx-auto"
  // //     //   style={{ color: SIDEBAR_COLORS[2], fontSize: 20 }}
  // //     // />

  // //   child: [
  // //     {
  // //       text: "External Docket",
  // //       link: "/docket-tracking-panel/external-docket",
  // //       icon: ""
  // //     },
  // //     {
  // //       text: "Internal Docket",
  // //       link: "/docket-tracking-panel/internal-docket",
  // //       icon: ""
  // //     },
  // //     {
  // //       text: "Docket Pickup Process",
  // //       link: "/docket-tracking-panel/docket-pickup-process",
  // //       icon: ""
  // //     },
  // //     {
  // //       text: "Courier",
  // //       link: "/docket-tracking-panel/courier",
  // //       icon: ""
  // //     },
  // //     {
  // //       text: "Shipment",
  // //       link: "/docket-tracking-panel/shipment",
  // //       icon: ""
  // //     }
  // //   ]
  // // },
  // {
  //   text: "Line Application",
  //   link: "/line-application",
  //   icon: DashboardIcon,
  //     // <DialIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[3], fontSize: 20 }}
  //     // />

  //   child: [
  //     {
  //       text: "Application",
  //       link: "/line-application/applicattion",
  //       icon: ""
  //     },
  //     {
  //       text: "Underwriting Panel",
  //       link: "/line-application/underwriting-panel",
  //       icon: ""
  //     }
  //   ]
  // },
  // {
  //   text: "Full Payment Transection",
  //   link: "/full-payment-transection",
  //   icon: DashboardIcon
  //     // <MoneyIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Credit Card EMI",
  //   link: "/credit-card-emi",
  //   icon: DashboardIcon
  //     // <CreditCardIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[1], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Loans",
  //   link: "/loans",
  //   icon: DashboardIcon
  //     // <LoanIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[2], fontSize: 20 }}
  //     // />

  // },
  // {
  //   text: "Payments Section",
  //   link: "/payment-panel",
  //   icon: DashboardIcon,
  //     // <DocIcon
  //     //   className="mx-auto"
  //     //   style={{ color: SIDEBAR_COLORS[3], fontSize: 20 }}
  //     // />

  //   child: [
  //     {
  //       text: "Payments",
  //       link: "/payment-panel/payment",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     },
  //     {
  //       text: "Razorpay Payment",
  //       link: "/payment-panel/razorpay",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     },
  //     {
  //       text: "Payu Payment",
  //       link: "/payment-panel/payu",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     },
  //     {
  //       text: "Paytm payment",
  //       link: "/payment-panel/paytm",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     },
  //     {
  //       text: "Cash Detail Listings",
  //       link: "/payment-panel/cash_detail_listing",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     },
  //     {
  //       text: "Cash In Store Listing",
  //       link: "/payment-panelcash_in_store_listing",
  //       icon: (
  //         <MoneyIcon
  //           className="mx-auto"
  //           style={{ color: SIDEBAR_COLORS[0], fontSize: 20 }}
  //         />
  //       )
  //     }
  //   ]
  // },
];
